<!-- <template>
<div class="overlay" @click.self="closeModal">
    <div class="modal">
    <h2>{{ $t('EngineModal.Title') }}</h2>
    <div class="form-group">
        <label for="docEngine">{{ $t('EngineModal.SelectDocEngine') }}</label>
        <select id="docEngine" v-model="selectedEngine">
        <option v-for="engine in docEngines" :key="engine.name" :value="engine">
            {{ engine.name }}
        </option>
        </select>
    </div>
    <div v-if="selectedEngine">
    <div class="form-group">
        <label for="description">{{ $t('EngineModal.Description') }}</label>
        <input
        type="text"
        id="description"
        v-model="selectedEngine.description"
        placeholder="Enter username"
        />
    </div>
    <div class="form-group">
        <label for="username">{{ $t('EngineModal.Username') }}</label>
        <input
        type="password"
        id="username"
        v-model="selectedEngine.username"
        placeholder="Enter username"
        />
    </div>
    <div class="form-group">
        <label for="password">{{ $t('EngineModal.Password') }}</label>
        <input
        type="password"
        id="password"
        v-model="selectedEngine.password"
        placeholder="Enter password"
        />
    </div>
    </div>
    <div class="button-group">
        <button @click="uploadEdepp3">{{ $t('EngineModal.Upload') }}</button>
        <button @click="closeModal">{{ $t('EngineModal.Cancel') }}</button>
    </div>
    <div v-if="uploadResult" class="upload-result">
        <p :class="{ success: uploadResult.success, error: !uploadResult.success }">
        {{ uploadResult.message }}
        </p>
    </div>
    </div>
</div>
</template>

<script>
import { convertJsonToHtml } from '@/utils/convertJsonToHtml';
import { generateForDocEngine } from '@/utils/generateForDocEngine';
import { mapState } from 'vuex';
import JSZip from 'jszip';

export default {
name: 'EngineModal',
data() {
    return {
    selectedEngine: null,
    uploadResult: null,
    docEngines: [
        {
        name: 'Test Engine',
        url: 'http://vh-engine.cartago.com:9087/',
        description: 'Test',
        username: 'test',
        password: 'test',
        },
        {
        name: 'Test Engine 2',
        url: 'http://docker03.cartago.com:23087/',
        description: 'Test 2',
        username: 'test',
        password: 'test',
        },
        // Weitere Engines hier hinzufügen
    ],
    };
},
computed: {
    ...mapState(['emailData', 'mediaQueries', 'xPathPlaceholders', 'xmlFile', 'emailTitle']),
},
methods: {
    async uploadEdepp3() {
    const servers = [
        'https://html-creator.demo.cartago.com',
        'https://html-creator.demo.cartago.com',
        'http://demo.cartago.com:5050'
      ];
    this.uploadResult = null;

    if (!this.selectedEngine) {
        this.uploadResult = { success: false, message: 'Please select an engine' };
        return;
    }
    try {
        const edeppContent = await this.createDeploymentPackage();
        const base64Content = await this.convertBlobToBase64(edeppContent);

        const response = await fetch(`${servers[1]}/proxy/upload-edepp`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                url: `${this.selectedEngine.url}rest/templates/template/${encodeURIComponent(this.emailTitle)}.edepp`,
                edeppContent: base64Content,
                username: this.selectedEngine.username,
                password: this.selectedEngine.password,
            }),
        });

        const result = await response.json();
        if (result.success) {
            this.uploadResult = {
                success: true,
                message: `Freigabe erfolgreich unter: ${this.emailTitle}.edepp`,
            };
        } else {
            this.uploadResult = { success: false, message: result.message };
        }
    } catch (error) {
        this.uploadResult = { success: false, message: `Fehler: ${error.message}` };
    }
},
    // Hilfsfunktion zur Konvertierung eines Blobs in Base64
    convertBlobToBase64(blob) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result.split(',')[1]); // Base64-Teil extrahieren
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    },
    async createDeploymentPackage() {
    const zip = new JSZip();
    const jsonData = {
    ...this.emailData,
    mediaQueries: this.mediaQueries, // Insert Media Queries here
    mapping: this.xPathPlaceholders, // Insert Placeholder Mapping here
    };
    zip.file(`${this.emailTitle}.json`, JSON.stringify(jsonData, null, 2));// zip the json file

    const htmlFile = convertJsonToHtml(this.emailData, false);
    zip.file(`${this.emailTitle}.html`, htmlFile); //zip the html file

    const xslFile = generateForDocEngine();
    zip.file(`${this.emailTitle}_html.xsl`, xslFile); //zip the xsl file

    const xmlData = this.xmlFile
    zip.file('design.xml', xmlData); // XML-Datei einfügen

    const content = await zip.generateAsync({ type: 'blob' });
    const edeppFile = new File([content], 'template.edepp', { type: 'application/zip' });
    return edeppFile;
    // saveAs(content, `${this.emailTitle}.edepp`);
},
    closeModal() {
    this.$emit('close');
    },
},
};
</script>

<style scoped>
.overlay {
position: fixed;
top: 0;
left: 0;
width: 100%;
height: 100%;
background: rgba(0, 0, 0, 0.5);
display: flex;
justify-content: center;
align-items: center;
z-index: 1000;
}

.modal {
background: white;
padding: 20px;
border-radius: 8px;
width: 400px;
text-align: left;
}

.form-group {
margin-bottom: 15px;
}

label {
display: block;
margin-bottom: 5px;
}

input,
select {
width: 100%;
padding: 8px;
box-sizing: border-box;
}

.button-group {
display: flex;
justify-content: space-between;
gap: 10px;
}

button {
padding: 10px 20px;
border: none;
border-radius: 4px;
cursor: pointer;
background: var(--primary-color);
color: white;
}

button:hover {
background: var(--secondary-color);
}

.upload-result {
margin-top: 10px;
}

.success {
color: green;
}

.error {
color: red;
}
</style>
   -->
<template>
  <div class="overlay" @click.self="closeModal">
    <div class="modal">
      <h2>{{ $t('EngineModal.Title') }}</h2>
      <div class="table-container">
        <table class="engine-table">
          <thead>
            <tr>
              <th><input type="checkbox" @change="toggleSelectAll" /></th>
              <th>{{ $t('EngineModal.Name') }}</th>
              <th>{{ $t('EngineModal.Description') }}</th>
              <th>{{ $t('EngineModal.Url') }}</th>
              <th>{{ $t('EngineModal.Username') }}</th>
              <th>{{ $t('EngineModal.Password') }}</th>
              <th>{{ $t('EngineModal.Action') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(engine, index) in docEngines" :key="index">
              <td style="width: 2%"><input type="checkbox" v-model="engine.selected" /></td>
              <td style="width: 15%"><input type="text" v-model="engine.name" /></td>
              <td style="width: 20%"><input type="text" v-model="engine.description" /></td>
              <td style="width: 30%"><input type="text" v-model="engine.url" /></td>
              <td style="width: 14%"><input style="width: 100%" type="password" v-model="engine.username" /></td>
              <td style="width: 14%"><input style="width: 100%" type="password" v-model="engine.password" /></td>
              <td style="width: 5%"><button style="width: 100%" @click="removeEngine(index)" class="delete-button"> 
                <span class="material-symbols-outlined">delete</span>
            </button></td>
            </tr>
          </tbody>
        </table>
        <button style="display: flex; margin-left: 15px;" @click="addEngine">{{ $t('EngineModal.Add') }}</button>
      </div>
      <div class="button-group">
        <button @click="uploadSelected">{{ $t('EngineModal.Upload') }}</button>
        <button @click="closeModal">{{ $t('EngineModal.Cancel') }}</button>
      </div>
      <div v-for="(result, index) in uploadResults" :key="index" class="upload-result">
        <p :class="{ success: result.success, error: !result.success }">{{ docEngines.find(item => item.id === result.id)?.name}}: {{ result.message }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { convertJsonToHtml } from '@/utils/convertJsonToHtml';
import { generateForDocEngine } from '@/utils/generateForDocEngine';
import { generateMetaXML } from '@/utils/createMetaXml';
import { mapState } from 'vuex';
import JSZip from 'jszip';
import TabHandler from '../TabHandler.vue';

export default {
  components: { TabHandler },
  name: 'EngineModal',
  data() {
    return {
      docEngines: [
      {
        id: '56785678',
        name: 'Test Engine',
        url: 'http://vh-engine.cartago.com:9087/',
        description: 'Test',
        username: 'cartago',
        password: 'cartago',
        },
        {
        id: '77373737',
        name: 'Test Engine 2',
        url: 'http://docker03.cartago.com:23087/',
        description: 'Test 2',
        username: 'cartago',
        password: 'cartago',
        selected: false
        },
        // Weitere Engines hier hinzufügen
      ],
      uploadResults: [],
    };
  },
  computed: {
    ...mapState(['emailData', 'mediaQueries', 'xPathPlaceholders', 'xmlFile', 'emailTitle']),
  },
  methods: {
    toggleSelectAll(event) {
      const isSelected = event.target.checked;
      this.docEngines.forEach((engine) => {
        engine.selected = isSelected;
      });
    },
    addEngine() {
        const newId = Math.floor(10000000 + Math.random() * 90000000).toString();
      this.docEngines.push({
        newId,
        name: '',
        description: '',
        url: '',
        username: '',
        password: '',
        selected: false,
      });
    },
    removeEngine(index) {
      this.docEngines.splice(index, 1);
    },
    async uploadSelected() {
       
      this.uploadResults = [];
      for (const engine of this.docEngines) {
        if (engine.selected) {
          try {
            const result = await this.uploadEdepp(engine);
            const id = engine.id
            this.uploadResults.push({id, ...result});
          } catch (error) {
            this.uploadResults.push({ success: false, message: `Fehler bei ${engine.name}: ${error.message}` });
          }
        }
      }
      console.log(this.uploadResults)
    },
    async uploadEdepp(engine) {
    const servers = [
        'https://html-creator.demo.cartago.com',
        'https://html-creator.demo.cartago.com',
        'http://demo.cartago.com:5050'
      ];
    this.uploadResult = null;

    if (!engine) {
        // this.uploadResult = { success: false, message: 'Please select an engine' };
        return { success: false, message: 'Please select an engine' };
    }
    try {
        const edeppContent = await this.createDeploymentPackage();
        const base64Content = await this.convertBlobToBase64(edeppContent);

        const response = await fetch(`/proxy/upload-edepp`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                url: `${engine.url}rest/templates/template/${encodeURIComponent(this.emailTitle)}.edepp`,
                edeppContent: base64Content,
                username: engine.username,
                password: engine.password,
            }),
        });

        const result = await response.json();
        if (result.success) {
            return {
                success: true,
                message: `Freigabe erfolgreich unter: ${this.emailTitle}.edepp`,
            };
        } else {
            return { success: false, message: result.message };
        }
    } catch (error) {
        return { success: false, message: `Fehler: ${error.message}` };
    }
    },
    convertBlobToBase64(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result.split(',')[1]);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    },
    async createDeploymentPackage() {
      const zip = new JSZip();
      const jsonData = {
        ...this.emailData,
        mediaQueries: this.mediaQueries,
        mapping: this.xPathPlaceholders,
      };
      zip.file(`${this.emailTitle}.json`, JSON.stringify(jsonData, null, 2));

      const htmlFile = convertJsonToHtml(this.emailData, false);
      zip.file(`${this.emailTitle}.html`, htmlFile);

      const xslFile = generateForDocEngine();
      zip.file(`${this.emailTitle}_html.xsl`, xslFile);

      zip.file('design.xml', this.xmlFile);

      /* const metaData = generateMetaXML()
      zip.file('meta.xml', metaData) */

      const content = await zip.generateAsync({ type: 'blob' });
      return new File([content], 'template.edepp', { type: 'application/zip' });
    },
    closeModal() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 950px;
  max-width: 100%;
  overflow-y: auto;
}

.table-container {
  margin-bottom: 20px;
}

.table-header {
  margin-bottom: 10px;
}

.engine-table {
  width: 100%;
  border-collapse: collapse;
  
}

.engine-table th,
.engine-table td {
  border: 0px solid #ddd;
  padding: 8px;
  text-align: left;
}

.button-group {
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
  gap: 10px;
}


button {
  padding: 5px 10px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  background: var(--primary-color);
  color: white;
}

button:hover {
  background: var(--secondary-color);
}

.upload-result {
  margin-top: 10px;
}

.success {
  color: green;
}

.error {
  color: red;
}

input{
    all: revert;
    font-size: 14px;
    width: 100%;
    padding: 3px;
    
}

</style>

